module.exports = __webpack_public_path__ + "img/23.6842a494.png";